import type { NeonFailureReason } from '@cli-types/next-adapter/vercel.js'

export function neonFailureMessage(reason?: NeonFailureReason): string {
  switch (reason) {
    case 'terms-required':
      return 'Provisioning needs the Neon marketplace terms accepted — falling back to manual entry.'
    case 'claim-required':
      return 'The Neon resource needs to be claimed — falling back to manual entry.'
    case 'timeout':
      return 'Neon provisioning timed out — falling back to manual entry.'
    default:
      return 'Neon provisioning did not complete — falling back to manual entry.'
  }
}
